export default {
	primaryColor: '#007bff',
	primaryBackground: '#fff',
}
